module.exports = __webpack_public_path__ + "img/pngtree-university-emblem-logo-image_83109.bfdf4e79.jpg";